import React from 'react'

export default function BellTowerLogo(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      id="a"
      xmlns="http://www.w3.org/2000/svg"
      width="59.9"
      height="96.8"
      viewBox="0 0 59.9 96.8"
      {...props}
    >
      <path d="m33.2,34.6v.1l4.5,1.4c-4.2-3-5.9-8.5-5.9-8.5h1v-1.2h-1.7c1-.4,1.6-1.3,1.6-2.5,0-.6-.2-1.2-.6-1.7l-.1-.1-.1-.1c-.2-.2-.5-.4-.8-.5l-.8-21.5h-.3l-.8,21.4c-.3.1-.6.3-.8.5l-.1.1c0,.1-.1.1-.1.1-.4.5-.6,1-.6,1.7,0,1.1.7,2.1,1.6,2.5h-1.7v1.2h1s-1.6,5.5-5.9,8.5l4.5-1.4h6.1Z" />
      <path d="m47.1,94v-17.9c-.1-3.9-2.2-4.5-2.2-4.5,0,0-3.2-1.6-3.1,2.1v20.3h-7.8v-20.1c.1-4.1-4.2-4.1-4.2-4.1,0,0-4.5-.2-4.4,4v20.2h-4.4v-29.4h18.4l11.5,4.6v6.2l3.2-4,.9-3.3-16.7-7.3h-17.5l-.8-1.4h18.3l13.5,5.9c-.1-1-.4-17.4-14.3-27.8l-3.6-1.1s14.2,8.4,14.8,24.9l-10.2-4c-.2-3-.8-8.9-3.1-14.7-.2-.4-.3-.9-.5-1.3-.8-1.7-1.7-3.5-2.9-5.1h-5l-4.4,1.4c-9.1,6.3-12.5,17.1-13.7,23.3-.4,2.1-.8,5.7-.8,5.7l-3.1,1.4,1,3.6,2.8,3.3v19.1H0l2.3,2.8h55.3l2.3-2.8h-12.8Zm-28.9,0h-5.4v-17c0-3.7,2.4-5.5,2.4-5.5,0,0,2.8-1.7,3,1.3v21.2Z" />
    </svg>
  )
}
